"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = require("../message/Message");
const react_1 = __importDefault(require("react"));
const RedeemSectionPsnWarning = () => {
    return react_1.default.createElement("span", { className: "psnWarning" }, Message_1.localizedMessage('errors.com.epicgames.posa.psn.country.not.supported'));
};
exports.default = RedeemSectionPsnWarning;
//# sourceMappingURL=RedeemSectionPsnWarning.js.map